//Componente importado de material ui
import { createMuiTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
//Estilo genérico importado
import { estilosTextosPrincipales, colores } from '../../../AppStyle';
/**
 * Classes creadas para aplicar al componente
 */


export const overMiniInputs = createMuiTheme({
    overrides: {
        MuiFormHelperText: {//Clases aplicadas en los helpTexts
            root: {
                ...estilosTextosPrincipales.body2,
                color: colores.estado.error,
                fontSize: '12px',
            },
            contained: {
                marginLeft: '0px',
                marginRight: '0px',
            }
        },
        MuiInputBase: {//Clases aplicadas en los inputs
            root: {
                height: '48px',
                width: '148px',
                '&$disabled': {//Clase aplicada cuando el input está deshabilitado
                    backgroundColor: colores.escalaGrises.diez,
                },
            },
            input: {
                ...estilosTextosPrincipales.body2,
                fontSize: '14px',
                //lineHeight: '24px',
                letterSpacing: '0px',
                color: colores.escalaGrises.cien,
                '&::placeholder': {
                    ...estilosTextosPrincipales.body2,
                    fontSize: '14px',
                    //lineHeight: '24px',
                    letterSpacing: '0px',
                    opacity: '0.8',
                    color: colores.escalaGrises.apoyo,
                },
            },
        },
        MuiOutlinedInput: {//Clases aplicadas a los bordes de los inputs
            root: {
                '&:hover $notchedOutline': {
                    border: '2px',
                    borderStyle: 'solid',
                    borderColor: colores.principales.principal,
                },
                '&$focused $notchedOutline': {
                    border: '2px',
                    borderStyle: 'solid',
                    borderColor: colores.principales.principal,
                }
            },
            notchedOutline: {
                border: '1px solid',
                borderColor: colores.principales.apoyo,
                boxSizing: 'border-box',
                borderRadius: '4px',
            },
        },
        MuiInputLabel: {//Evita que se reduzca el título
            shrink: {
                transform: 'none'
            },
        },
    },
});

///////////////////////////////CONTAINER
export default makeStyles({
    classContainer: {
        width: '1170px',
        height: 'auto',
    },
    ///////////////////////////////GRIDS
    classGrid: { //Clase del container que contiene el Input (desde el componente Input)
        textAlign: 'left',
        marginTop: '15px',
        marginBottom: '19px',
        marginRight: '32px',
        width: 'auto',
        display: 'block',
    },
    classGridEncabezado: {
        width: 'auto',
        marginTop: '19.51px',
        marginBottom: '32px',
    },
    classGridDireccionContenedor: {
        display: 'flex',
        width: '100%',
    },
    classGridBloque2Campos:{ // Clase del container que contiene dos campos
        width: 'auto'
    },
    ///////////////////////////////TITULO
    classEncabezadoH2: {
        ...estilosTextosPrincipales.encabezadoH2,
        color: colores.escalaGrises.cien,
    },
    classEncabezadoH3: {
        ...estilosTextosPrincipales.encabezadoH3,
        color: colores.escalaGrises.cien,
    },
    ///////////////////////////////InputLabel
    classInputLabel: {
        ...estilosTextosPrincipales.body2,
        color: colores.escalaGrises.ochenta,
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '0',
        lineHeight: ' 17px',
        marginBottom: '5px',
        position: 'relative',
        '&.Mui-focused': {
            color: '#555555',
        },
    },
    classSpanRequired: {
        color: colores.principales.required,
        ...estilosTextosPrincipales.body2,
    }
});